<p>&#169; Starter Project {{ currentYear }}</p>
